/** Every field in the tree, at any depth, including the rows of a collection. */
function fieldsOf(node, into) {
    if (!node || typeof node !== "object")
        return into;
    if (node.node === "field")
        into.push(node);
    if (Array.isArray(node.children))
        for (const child of node.children)
            fieldsOf(child, into);
    fieldsOf(node.item, into);
    return into;
}
/**
 * One `warning` per field whose kind the target does not declare, and nothing at all otherwise.
 *
 * `warning` rather than `error`: the field is generated, so the project is still compatible — what
 * is lost is the rendering the author asked for, and an error here would cost them every other
 * field to report one.
 */
export function capabilityDiagnostics(project, target) {
    const declared = new Set(target.capabilities.fieldKinds);
    return fieldsOf(project.schema, [])
        .filter((field) => typeof field.fieldKind === "string" && !declared.has(field.fieldKind))
        .map((field) => ({
        code: "UNSUPPORTED_FIELD_KIND",
        severity: "warning",
        targetId: target.id,
        ...(field.id === undefined ? {} : { nodeId: field.id }),
        message: `Field "${field.name ?? field.id ?? "(unnamed)"}" has kind "${String(field.fieldKind)}", which this ` +
            `target does not support — it is generated as a plain field, so what it holds survives and the ` +
            `control the author chose does not.`,
    }));
}
